exports = module.exports = require("../../../../css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".progress-bar{position:absolute;top:0;left:0;height:4px;background:#fff;width:0;transition:width .25s;z-index:1049}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /~/css-loader!/~/postcss-loader!/~/eoxc/src/contrib/OpenLayers/progressbar.css
// module id = 1970
// module chunks = 0